import Input from './Input';

export default Input;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-input/es/index.js
// module id = 305
// module chunks = 0